import { Box, Typography } from "@mui/material"
import { TimeRemainingProps } from "./types"
import { icons } from "../../../../../../utils/icons"
import dayjs from "dayjs";
import { Constants } from "../../../../../../utils/constants";
import { useStyles } from "./styles";
import { useNow } from "../../hooks/useNow";
import { Status } from "../../../../../../utils/enums";



const TimeRemaining = ({ requestDate, limitDate, show, flag }: TimeRemainingProps) => {

    const styles = useStyles();

    const now = useNow();

    if (!requestDate || !limitDate) return null;

    const start = dayjs(requestDate, Constants.dayjsFormat);
    const end = dayjs(limitDate, Constants.dayjsFormat);
    const current = dayjs(now);

    let secondsLeft = 0;

    if (flag) {
        secondsLeft = 0;
    } else if(current.isBefore(start)) {
        secondsLeft = Math.max(end.diff(start, "seconds"), 0);
    } else {
        secondsLeft = Math.max(end.diff(current, "seconds"), 0);
    }

    const isExpired = secondsLeft === 0;

    const days = Math.floor(secondsLeft / 86400).toString().padStart(2, "0");
    const hours = Math.floor((secondsLeft % 86400) / 3600).toString().padStart(2, "0");
    const minutes = Math.floor((secondsLeft % 3600) / 60).toString().padStart(2, "0");
    const seconds = (secondsLeft % 60).toString().padStart(2, "0");

    return (
        <>
            {show &&
                <Box sx={styles.container(isExpired)}>
                    {icons('timer')}

                    <Typography>
                        {days}:{hours}:{minutes}:{seconds}
                    </Typography>
                </Box>
            }
        </>
    )
}

export default TimeRemaining
